import useSWR from 'swr';
import { ShipmentsDetailsData } from '../../models/Shipments';
import httpApi from '../api/httpApi';

const URL = '/api/v1/sales-shipments/';

const useShipmentProductsSWR = (shipmentLabelId: string) => {
    const productsUrl = URL + shipmentLabelId;
    const fetch = (query): Promise<ShipmentsDetailsData[]> => {
        return httpApi
            .get<{ shipmentLabel: ShipmentsDetailsData[] }>(query)
            .then((res) => {
                return res.getData().shipmentLabel;
            })
            .catch((error) => {
                throw error;
            });
    };

    const { data, error, isLoading, mutate } = useSWR(productsUrl, fetch, {
        dedupingInterval: 1000 * 60 * 10,
        errorRetryCount: 0,
    });

    return {
        products: data ? data['sales-shipment'] : [],
        isLoading: isLoading,
        isError: error,
        forceRefresh: mutate,
        productNumber: data ? data.length : 0,
    };
};

export default useShipmentProductsSWR;
